<script lang="ts" setup>
import { Overlay } from "vant";
import { TextImage } from "@/types/entity1";
import TextImagePreview from "@/components/mobile/gallery/TextImagePreview.vue";

const props = defineProps<{
  show: boolean;
  list: TextImage[];
  idx: number;
  nextPageFunc: () => Promise<boolean> | boolean;
}>();
const emit = defineEmits<{
  (e: "update:show", val: boolean): void;
  (e: "update:idx", val: number): void;
}>();
</script>
<template>
  <Overlay
    :show="show"
    class="van-safe-area-top backdrop-blur-xl flex backdrop-brightness-50 z-[1999]"
    duration="0"
    teleport="#root-layout"
    @update:show="emit('update:show', $event)"
  >
    <TextImagePreview
      :idx="idx"
      :list="list"
      :next-page-func="nextPageFunc"
      :show="show"
      @update:idx="emit('update:idx', $event)"
      @update:show="emit('update:show', $event)"
    />
  </Overlay>
</template>
<style scoped>
.bg-overlay-blue {
  @apply bg-[rgba(13,14,18)];
}
</style>
